import React, { useEffect, useState } from "react";
import Button from "../../Common/Button";
import { useNavigate } from "react-router-dom";
import Modal from "../../Common/Modal ";
import NoDataFound from "../../Common/NoDataFound";

const MerchantDocument = ({ profileData }) => {
  const BASE_URL_IMG = process.env.REACT_APP_BASE_URL_IMG;

  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [currentDocument, setCurrentDocument] = useState(null);
  const [formData, setFormData] = useState(profileData);

  console.log(formData, "FormdataDocument");
  //   useEffect({
  //     if (profileData) {
  //         setFormData(profileData)
  //     }
  //   },[profileData])

  const openDocument = (type) => {
    setCurrentDocument(type);
    setIsOpen(true);
  };
  return (
    <>
      <div className="pt-8">
        <div className="mb-6 ">
          <div className="grid grid-cols-2 gap-10 text-gray-600">
            <div className="flex items-center justify-between">
              <strong>Aadhar Card</strong>
              <button
                className="p-2 bg-gray-100 rounded-full"
                onClick={() => openDocument("Aadhar")}
              >
                👁️
              </button>
            </div>
            <div className="flex items-center justify-between">
              <strong>Pan Card</strong>
              <button
                className="p-2 bg-gray-100 rounded-full "
                onClick={() => openDocument("Pan")}
              >
                👁️
              </button>
            </div>
          </div>
        </div>
        <div className=" xl:flex lg:flex md:flex  xm:flex   sm:flex justify-end gap-4 pt-5 xl:pt-0 lg:pt-0 ">
          <Button
            type="submit"
           className="border-custom-red border hover:border-custom-red w-full xl:mt-0 lg:mt-0 hover:text-white text-custom-red font-bold py-2 px-4 rounded-lg hover:bg-custom-red transition duration-300"
            text="Close"
            onClick={()=> navigate(-1)}
          />
        </div>

        <Modal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          title="View Document"
          childrenClass="w-full h-auto flex justify-center p-5"
          Classes="w-10/11 md:w-2/6 h-3/6"
        >
          {currentDocument === "Aadhar" && formData.aadhar ? (
            <img
              src={`${BASE_URL_IMG}/${formData.aadhar}`}
              alt="Aadhar Card"
              className="w-72 h-auto"
            />
          ) : currentDocument === "Pan" && formData.panCard ? (
            <img
              src={`${BASE_URL_IMG}/${formData.panCard}`}
              alt="Pan Card"
              className="w-72 h-auto"
            />
          ) : (
            <NoDataFound />
          )}
        </Modal>
      </div>
    </>
  );
};

export default MerchantDocument;
